import { useCallback, useRef } from 'react';
import type { DraggableEventHandler } from 'react-draggable';

export const useDraggableFab = (originalOnClick: () => void) => {
  const nodeRef = useRef<HTMLDivElement>(null);
  const hasDragged = useRef(false);
  const onClickRef = useRef(originalOnClick);
  onClickRef.current = originalOnClick;

  const onStart: DraggableEventHandler = useCallback(() => {
    hasDragged.current = false;
  }, []);

  const onDrag: DraggableEventHandler = useCallback(() => {
    hasDragged.current = true;
  }, []);

  const clickHandler = useCallback(() => {
    if (!hasDragged.current) {
      onClickRef.current();
    }
  }, []);

  return {
    nodeRef,
    onStart,
    onDrag,
    clickHandler,
  };
};
